import { ensureBundledocsActionCompleted } from './ensureBundledocsActionCompleted'
import { useMatterBundleStore } from '@repo/store/useMatterBundleStore'

export const deleteBundle = async (bundleData: any) => {
  await ensureBundledocsActionCompleted(bundleData, (suppressErrorToast: boolean) =>
    useMatterBundleStore.getState().deleteBundle({
      clientNo: bundleData?.clientNo,
      matterNo: bundleData?.matterNo,
      matterBundleId: bundleData?.matterBundleId,
      suppressErrorToast
    })
  )
}
